import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import Routes from "./Routes";
import "regenerator-runtime/runtime";
import "core-js/stable";
import posthog from "posthog-js";
import { ENV_POSTHOG_HOST, ENV_POSTHOG_KEY } from "./config/envVars";

if (ENV_POSTHOG_KEY && ENV_POSTHOG_HOST) {
  posthog.init(ENV_POSTHOG_KEY, {
    api_host: ENV_POSTHOG_HOST,
    ui_host: "https://eu.posthog.com",
    person_profiles: "always",
  });
}

export const routes = {
  App: "/",
  Home: "/",
  AccountView: "/account",
  OperationsView: "/operations",
  LoanCreationView: "/loan-application",
};

ReactDOM.render(
  // <React.StrictMode>
  <Routes />,
  // </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
